// extracted by mini-css-extract-plugin
export default {"root":"SpaceConsumptionWarning__root--2vPHq","close":"SpaceConsumptionWarning__close--_S1_j"};